const digest = 'f6303a5f9ca4715380d37e289dc4b2fa5016e2cfd0b44e3fdb088a57f3d42bee';
const css = `._viewHeight_11bag_1{height:100vh}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'viewHeight': '_viewHeight_11bag_1' };
export const viewHeight = '_viewHeight_11bag_1';
export { css, digest };